import { render } from "./main_page.vue?vue&type=template&id=0d7f5c6c&scoped=true"
import script from "./main_page.vue?vue&type=script&lang=js"
export * from "./main_page.vue?vue&type=script&lang=js"

import "./main_page.vue?vue&type=style&index=0&id=0d7f5c6c&scoped=true&lang=css"

import exportComponent from "/home/kabull/js/vue/iqtest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d7f5c6c"]])

export default __exports__